import { useCallback } from "react";
import LivePreview from "./LivePreview";
import Sidebar from "./Sidebar";
import { FormTemplate } from "../../../../types/forms";

interface FormBuilderEditorViewProps {
  templateState: FormTemplate;
  setTemplateState: React.Dispatch<React.SetStateAction<FormTemplate>>;
  currentSection: number;
  setCurrentSection: (value: number) => void;
}

export default function FormBuilderEditorView({
  templateState,
  setTemplateState,
  currentSection,
  setCurrentSection,
}: FormBuilderEditorViewProps) {
  const handleAddSection = useCallback(
    (section: FormTemplate["sections"][0]) => {
      setTemplateState((prev) => ({
        ...prev,
        sections: [...prev.sections, section],
      }));
    },
    [setTemplateState]
  );

  const handleDeleteSection = useCallback(
    (id: number | string) => {
      setTemplateState((prev) => ({
        ...prev,
        sections: prev.sections.filter((s) => s.id !== id),
      }));
    },
    [setTemplateState]
  );

  return (
    <div className="flex flex-row gap-3 h-[calc(100vh-140px)]">
      {/* Sidebar */}
      <div className="w-5/12">
        <Sidebar
          template={templateState}
          updateTemplate={setTemplateState}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          deleteSection={handleDeleteSection}
          addSection={handleAddSection}
        />
      </div>

      {/* Live Preview */}
      <div className="flex-1 overflow-y-auto pl-2 w-7/12 h-full">
        <LivePreview
          template={templateState}
          currentSection={currentSection}
          totalSections={templateState.sections.length}
        />
      </div>
    </div>
  );
}
